<div class="report row mx-md-0 px-md-0">
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-4 d-flex justify-content-start">
        <span class="">ID:</span>
      </div>
      <div class="col-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.idX1 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-4 d-flex justify-content-start">
        <span class="">Date:</span>
      </div>
      <div class="col-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.theDateX1 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-4 d-flex justify-content-start">
        <span class="">Time:</span>
      </div>
      <div class="col-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.theTimeX1 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-3 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-4 d-flex justify-content-start">
        <span class="">Cash In:</span>
      </div>
      <div class="col-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.cashInX1 | number }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-4 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-4 d-flex justify-content-start">
        <span class="">Cash Out:</span>
      </div>
      <div class="col-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.cashOutX1 | number }}
        </span>
      </div>
    </div>
  </div>
</div>
<div class="row pt-2 px-md-3">
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-4 d-flex justify-content-start">
        <span class="">Narration 1:</span>
      </div>
      <div class="col-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.narration1X1 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4" *ngIf="itm.narration2X1">
    <div class="row">
      <div class="col-4 d-flex justify-content-start">
        <span class="">Narration 2:</span>
      </div>
      <div class="col-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.narration2X1 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Officer:</span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.userNameX1 }}
        </span>
      </div>
    </div>
  </div>
</div>
<div class="row mt-md-2 pt-2 pb-1 border-top">
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Station:</span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.stationNameX1 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Total Balance:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.balanceX1 | number }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-6 col-md-5 d-flex justify-content-start">
        <span class="">Transaction Type:</span>
      </div>
      <div class="col-6 col-md-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.txnTypeX1 }}
        </span>
      </div>
    </div>
  </div>
</div>
